import {
  faCog,
  faSlidersH,
  faUsers,
  faHistory,
  faVial,
  faVials,
  faCopy,
  faRestroom,
  faFlask,
  faStickyNote,
  faFileInvoiceDollar,
  faPrint
} from "@fortawesome/free-solid-svg-icons";

const menu = [
  {
    id: 100,
    text: "تنظیمات",
    icon: faCog,
    path: "/setting",
  },
  {
    id: 120,
    text: "تنظیمات پیشرفته",
    icon: faSlidersH,
    path: "/advancesetting",
    isHidden: true,
  },
  {
    id: 300,
    text: "مدیریت دوره ها",
    icon: faHistory,
    path: "/periods",
  },
  {
    id: 200,
    text: "مدیریت کاربران",
    icon: faUsers,
    path: "/users",
  },
  {
    id: 400,
    text: "مدیریت مشتریان",
    icon: faRestroom,
    path: "/clients",
  },
  {
    type: "sep",
    container: [100, 120, 200, 300, 400],
  },
  {
    id: 500,
    text: "مدیریت آزمون ها",
    icon: faVial,
    path: "/exams",
  },
  {
    id: 550,
    text: "مدیریت روش های آزمون",
    icon: faVials,
    path: "/methods",
  },
  {
    id: 600,
    text: "مدیریت درخواست ها",
    icon: faCopy,
    path: "/requests",
  },
  {
    type: "sep",
    container: [500, 550, 600],
  },
  {
    id: 700,
    text: "نتایج میکروبی",
    icon: faFlask,
    path: "/microbilaresults",
    search: "type=1&title=میکروبی",
  },
  {
    id: 710,
    text: "نتایج شیمیایی",
    icon: faFlask,
    path: "/chemicalresults",
    search: "type=2&title=شیمیایی",
  },
  {
    id: 720,
    text: "نتایج سلولزی",
    icon: faFlask,
    path: "/celluloseresults",
    search: "type=3&title=سلولزی",
  },
  {
    id: 730,
    text: "نتایج بسته بندی",
    icon: faFlask,
    path: "/packingresults",
    search: "type=4&title=بسته بندی",
  },
  {
    id: 740,
    text: "نتایج محیط زیست",
    icon: faFlask,
    path: "/environmentresults",
    search: "type=5&title=محیط زیست",
  }, {
    id: 741,
    text: "نتایج جذب اتمی",
    icon: faFlask,
    path: "/atomiresults",
    search: "type=6&title=جذب اتمی",
  }, {
    id: 742,
    text: "نتایج کروماتوگرافی گازی",
    icon: faFlask,
    path: "/gaziresults",
    search: "type=7&title=کروماتوگرافی گازی",
  }, {
    id: 743,
    text: "نتایج کروماتوگرافی مایع",
    icon: faFlask,
    path: "/mayeresults",
    search: "type=8&title=کروماتوگرافی مایع",
  }, {
    id: 744,
    text: "نتایج نساجی",
    icon: faFlask,
    path: "/nasajiresults",
    search: "type=9&title=نساجی",
  }, {
    id: 745,
    text: "نتایج مهندسی پزشکی",
    icon: faFlask,
    path: "/pezeshkiresults",
    search: "type=10&title=مهندسی پزشکی",
  }, {
    id: 746,
    text: "نتایج آرایشی بهداشتی",
    icon: faFlask,
    path: "/behdashtiresults",
    search: "type=11&title=آرایشی بهداشتی",
  },
  {
    id: 750,
    text: "مدیریت نتایج",
    icon: faStickyNote,
    path: "/resultsmanagement",
  },
  {
    type: "sep",
    container: [700, 710, 720, 730, 740, 750],
  },
  {
    id: 800,
    text: "مدیریت صورتحساب ها",
    icon: faFileInvoiceDollar,
    path: "/invoicemanagement",
  },
  {
    id: 850,
    text: "گزارش درخواست ها",
    icon: faPrint,
    path: "/requestsreport",
  },
  {
    id: 860,
    text: "گزارش نمونه ها",
    icon: faPrint,
    path: "/samplesreport",
  },
  {
    id: 880,
    text: "گزارش فاکتورهای رسمی",
    icon: faPrint,
    path: "/factorsreport",
  },
  {
    type: "sep",
    container: [800, 850, 860],
  },
];

export default menu;
